<template>
	<NewItem
		ref="newItem"
		button-title="New Report"
	>
		<template slot="form">
			<ReportForm @new-report="submit">
				<v-btn
					slot="buttons"
					flat
					color="error"
					@click="$refs.newItem.show = false"
				>
					close
				</v-btn>
			</ReportForm>
		</template>
	</NewItem>
</template>

<script>
import NewItem from '@/components/NewItem';
import ReportForm from '@/components/Report/ReportForm';

export default {
	components: {
		NewItem,
		ReportForm,
	},
	methods: {
		submit(report) {
			report.projectId = this.$store.get('projects/currentProject').id;
			report.save().then(() => {
				const reports = this.$store.get('reports/active');
				reports.add(report);
				this.$router.push({ name: 'ArticlesList', params: { reportId: report.id } });
				this.$notify('success', `Report "${report.displayName}" has been created.`);
			}).catch((error) => {
				// front-end validation error
				if (!!error.message && !!error.errors) {
					if (!!Object.values(error.errors)[0][0])
						this.$notify('error', `Validation error: ${Object.values(error.errors)[0][0]}`);
					else
						this.$notify('error', `Unknown validation error: ${error.message}`);
					return;
				}
				// back-end request error
				// Validation error can only occur if the name, date, project combo already was taken
				if (error.response.response.status === 422) {
					this.$notify('error', 'The combination of Name, Date, and Project has already been taken.');
					return;
				}
				this.$notify('error', `Failed to create new report "${report.displayName}".`);
			});
			this.$refs.newItem.close();
		},
	},
};
</script>

<style>

</style>
